// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2EcVi","paramInput":"JobSimulator_paramInput__5kGIU","input":"JobSimulator_input__23TYy"};